const COOKIE_CONSENT_STORAGE_KEY = 'cookieConsent';
const COOKIE_CONSENT_EXPIRY_DAYS = 180;
const COOKIE_CONSENT_BANNER_SELECTOR = '#cookie-consent';
const COOKIE_CONSENT_CHOICES_MAP = {
    all: {
        buttonSelector: '#cookie-consent-accept-all',
        hasNonEssentialConsent: true,
    },
    essential: {
        buttonSelector: '#cookie-consent-accept-essential',
        hasNonEssentialConsent: false,
    },
};
const NON_ESSENTIAL_SCRIPT_SELECTOR = '[data-cookie-consent-script]';



const consentBanner = document.querySelector(COOKIE_CONSENT_BANNER_SELECTOR);
const nonEssentialScriptTargetsMap = {
    head: { parent: document.head, anchor: null },
    bodyOpen: { parent: document.body, anchor: document.body.firstChild },
    bodyClose: { parent: document.body, anchor: null },
};

let isNonEssentialScriptsActivated = false;

const readStoredConsent = () => {
    try {
        return JSON.parse(localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY) || 'null');
    } catch (error) {
        return null;
    }
};

const writeStoredConsent = (consent) => {
    try {
        localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, JSON.stringify(consent));
    } catch (error) {
        // Storage blocked: the choice applies to this page view only
    }
};

const isConsentValid = (consent) => consent && consent.expiresAt && Date.now() < consent.expiresAt;

const hasNonEssentialConsent = (choice) => {
    const choiceConfig = COOKIE_CONSENT_CHOICES_MAP[choice];

    return choiceConfig ? choiceConfig.hasNonEssentialConsent : false;
};

const createExecutableFragment = (nonEssentialScriptTemplate) => {
    const nonEssentialScriptFragment = document.importNode(nonEssentialScriptTemplate.content, true);

    nonEssentialScriptFragment.querySelectorAll('script').forEach((inertScript) => {
        const executableScript = document.createElement('script');

        Array.from(inertScript.attributes).forEach((attribute) => {
            executableScript.setAttribute(attribute.name, attribute.value);
        });
        executableScript.text = inertScript.text;

        inertScript.replaceWith(executableScript);
    });

    return nonEssentialScriptFragment;
};

const activateNonEssentialScripts = () => {
    if (isNonEssentialScriptsActivated) {
        return;
    }
    isNonEssentialScriptsActivated = true;

    document.querySelectorAll(NON_ESSENTIAL_SCRIPT_SELECTOR).forEach((nonEssentialScriptTemplate) => {
        const { parent, anchor } = nonEssentialScriptTargetsMap[nonEssentialScriptTemplate.dataset.cookieConsentPlacement]
            ?? nonEssentialScriptTargetsMap.bodyClose;

        parent.insertBefore(createExecutableFragment(nonEssentialScriptTemplate), anchor);
    });
};

const setConsent = (choice) => {
    writeStoredConsent({
        choice: choice,
        expiresAt: Date.now() + COOKIE_CONSENT_EXPIRY_DAYS * 24 * 60 * 60 * 1000,
    });

    if (consentBanner) {
        consentBanner.classList.add('hidden');
    }

    if (hasNonEssentialConsent(choice)) {
        activateNonEssentialScripts();
    }
};

const storedConsent = readStoredConsent();

if (isConsentValid(storedConsent)) {
    if (hasNonEssentialConsent(storedConsent.choice)) {
        activateNonEssentialScripts();
    }
} else if (consentBanner) {
    consentBanner.classList.remove('hidden');
}

Object.entries(COOKIE_CONSENT_CHOICES_MAP).forEach(([choice, choiceConfig]) => {
    const button = document.querySelector(choiceConfig.buttonSelector);

    if (button) {
        button.addEventListener('click', () => setConsent(choice));
    }
});
